import React from "react";
import { observer } from "mobx-react";
import { UserWidgetConfigCreateStore } from "../../store";
import { UserWidgetConfigCreateForm } from "./UserWidgetConfigCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type UserWidgetConfigCreateProps = {
  userWidgetConfigCreateStore: UserWidgetConfigCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const UserWidgetConfigCreate: React.FC<UserWidgetConfigCreateProps> =
  observer(
    ({ userWidgetConfigCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={userWidgetConfigCreateStore.isSaving} />
          <UserWidgetConfigCreateForm
            userWidgetConfigCreateStore={userWidgetConfigCreateStore}
            userError={userWidgetConfigCreateStore.errors.user?.message}
            onUserChange={(value) => {
              userWidgetConfigCreateStore.setUserValue(value);
            }}
            userSelectedValue={
              userWidgetConfigCreateStore.entityValues.showUser
            }
            onUserSelected={(value) => {
              userWidgetConfigCreateStore.setSelectedUser(value);
            }}
            userOptions={userWidgetConfigCreateStore.getUserOptions()}
            widgetError={userWidgetConfigCreateStore.errors.widget?.message}
            onWidgetChange={(value) => {
              userWidgetConfigCreateStore.setWidgetValue(value);
            }}
            widgetSelectedValue={
              userWidgetConfigCreateStore.entityValues.showWidget
            }
            onWidgetSelected={(value) => {
              userWidgetConfigCreateStore.setSelectedWidget(value);
            }}
            widgetOptions={userWidgetConfigCreateStore.getWidgetOptions()}
            enabledError={userWidgetConfigCreateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              userWidgetConfigCreateStore.setEnabledValue(value);
            }}
            enabled={userWidgetConfigCreateStore.entityValues.enabled}
            positionError={userWidgetConfigCreateStore.errors.position?.message}
            onPositionChange={(value: string) => {
              userWidgetConfigCreateStore.setPositionValue(value);
            }}
            position={userWidgetConfigCreateStore.entityValues.position}
            configOverrideError={
              userWidgetConfigCreateStore.errors.configOverride?.message
            }
            onConfigOverrideChange={(value: string) => {
              userWidgetConfigCreateStore.setConfigOverrideValue(value);
            }}
            configOverride={
              userWidgetConfigCreateStore.entityValues.configOverride
            }
            displayOrderError={
              userWidgetConfigCreateStore.errors.displayOrder?.message
            }
            onDisplayOrderChange={(value: number | undefined) => {
              userWidgetConfigCreateStore.setDisplayOrderValue(value);
            }}
            displayOrder={userWidgetConfigCreateStore.entityValues.displayOrder}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={userWidgetConfigCreateStore.isProcessing}
            onSave={() => userWidgetConfigCreateStore.saveNewUserWidgetConfig()}
            onCancel={() =>
              userWidgetConfigCreateStore.cancelNewUserWidgetConfig()
            }
          />
          <ErrorDialog
            open={userWidgetConfigCreateStore.errorDialogOpened}
            title={userWidgetConfigCreateStore.errorTitle}
            description={userWidgetConfigCreateStore.errorDescription}
            onClose={() => userWidgetConfigCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
